'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconThumbtack, iconThumbtackTag } from '@ni/nimble-components/dist/esm/icons/thumbtack';
import { wrap } from '../../utilities/react-wrapper';

export type { IconThumbtack };
export { iconThumbtackTag };
export const NimbleIconThumbtack = wrap(IconThumbtack);